module.exports = __webpack_public_path__ + "static/media/hanoi.92198393.jpg";